import { render, staticRenderFns } from "./insureIframe.vue?vue&type=template&id=eb0c3c8c&scoped=true&"
import script from "./insureIframe.vue?vue&type=script&lang=js&"
export * from "./insureIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb0c3c8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eb0c3c8c')) {
      api.createRecord('eb0c3c8c', component.options)
    } else {
      api.reload('eb0c3c8c', component.options)
    }
    module.hot.accept("./insureIframe.vue?vue&type=template&id=eb0c3c8c&scoped=true&", function () {
      api.rerender('eb0c3c8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Insurance/components/insureIframe.vue"
export default component.exports